export async function getFedopsLogger(editorSDK, essentials) {
    const [metaSiteId, appDefinitionId] = await Promise.all([
        editorSDK.info.getMetaSiteId('token'),
        editorSDK.info.getAppDefinitionId('token'),
    ]);
    const fedopsLogger = essentials.fedopsLoggerFactory('blocks-widget-services', {
        customParams: {
            metaSiteId,
            appDefinitionId,
        },
    });
    return fedopsLogger;
}
//# sourceMappingURL=getFedopsLogger.js.map